/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import EmailLink from '../../../../client/js/components/links/EmailLink'
import PhoneLink from '../../../../client/js/components/links/PhoneLink'
import SelectableRow from '../../../../client/js/components/selection/SelectableRow'
import { getCustomerName } from '../../lib/customer.mjs'
import {
  getCustomerEstateListLink,
  getCustomerLeaseListLink,
  getCustomerLink,
  getCustomerMandateListLink,
  getCustomerProspectingListLink,
  getCustomerReportLink
} from '../../lib/links/customerLinks'
import { Menu, Table } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import QuickMenu from '../QuickMenu'
import { Link } from 'react-router-dom'
import RequirePerm from '../../../auth/components/RequirePerm'

export type CustomerListItemProps = {
  item: Customer
}

function CustomerListItem (props: CustomerListItemProps) {
  const intl = useIntl()
  const { item } = props
  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <AnchorLink to={getCustomerLink(item.id)}>
          {getCustomerName(item)}
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        <PhoneLink phone={item.mobile} />
      </Table.Td>
      <Table.Td>
        <PhoneLink phone={item.phone} />
      </Table.Td>
      <Table.Td>
        <EmailLink email={item.email} />
      </Table.Td>
      <Table.Td ta="end">
        <QuickMenu buttonProps={{ size: 'xs' }}>
          <Menu.Item component={Link} to={getCustomerEstateListLink(item.id)}>
            {intl.formatMessage({
              id: 'estates',
              defaultMessage: 'Biens'
            })}
          </Menu.Item>
          <RequirePerm
            permissions={['read:lease']}
            render={() => (
              <Menu.Item component={Link} to={getCustomerLeaseListLink(item.id)}>
                {intl.formatMessage({
                  id: 'leases',
                  defaultMessage: 'Dossiers de location'
                })}
              </Menu.Item>
            )}
          />
          <RequirePerm
            permissions={['read:mandate']}
            render={() => (
              <Menu.Item component={Link} to={getCustomerMandateListLink(item.id)}>
                {intl.formatMessage({
                  id: 'mandates',
                  defaultMessage: 'Mandats'
                })}
              </Menu.Item>
            )}
          />
          <RequirePerm
            permissions={['read:prospecting']}
            render={() => (
              <Menu.Item component={Link} to={getCustomerProspectingListLink(item.id)}>
                {intl.formatMessage({
                  id: 'prospecting_list',
                  defaultMessage: 'Prospections'
                })}
              </Menu.Item>
            )}
          />
          <RequirePerm
            permissions={['read:management-report']}
            render={() => (
              <Menu.Item component={Link} to={getCustomerReportLink(item.id)}>
                {intl.formatMessage({
                  id: 'reports',
                  defaultMessage: 'Rapports'
                })}
              </Menu.Item>
            )}
          />
        </QuickMenu>
      </Table.Td>
    </SelectableRow>
  )
}

export default CustomerListItem
